// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"19a39b6db329d5f442ef","655":"be585d6c109a64f1cb47"}[chunkId] + ".js";
};